import { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { PerspectiveCamera } from "@react-three/drei";
import Model3D from "./Model3D";
import ParticleNetworkCanvas from "./ParticleNetworkCanvas";

function HeroVisual() {
  return (
    <div className="hero-visual-wrap" aria-hidden="true">
      <ParticleNetworkCanvas />
      <Canvas
        style={{ position: "absolute", inset: 0, zIndex: 2, pointerEvents: "none" }}
        gl={{ alpha: true }}
      >
        <PerspectiveCamera
          makeDefault
          fov={75}
          near={0.1}
          far={1000}
          position={[0, 6, 10]}
        />
        <ambientLight intensity={1.5} />
        <Suspense
          fallback={
            <mesh>
              <boxGeometry args={[1, 1, 1]} />
              <meshBasicMaterial wireframe />
            </mesh>
          }
        >
          <Model3D />
        </Suspense>
      </Canvas>
    </div>
  );
}

export default HeroVisual;
